import {
  IContentResponseApi,
  IResponseApi,
  IStatisticAgentByVendorChartDataResponse,
  IStatisticAgentPointChildrenParam,
  IStatisticAgentPointListByParentResponse,
  IStatisticAgentPointListByVendorResponse,
  IStatisticAgentPointParam,
  IStatisticAgentPointResponse,
  IStatisticDailyAgentListListResponse,
  IStatisticDailyGameProviderListResponse,
  IStatisticDailyParam,
  IStatisticDailyResponse,
  IStatisticVendorParamColumn,
  StatisticsEnum,
  IStatisticGameTableParam,
  IStatisticGameTableResponse,
  TODO,
} from '@/interfaces';
import { useMutation, useQuery } from '@tanstack/react-query';
import requestApi from '../config';
import { pointStatisticsByVendor } from '@/helpers';

const URL_STATISTIC_AGENT_POINT = 'trans-service/reports/agent-point';
const URL_STATISTIC_LIST_BY_PARENT = 'auth-service/agents/list/by-parent';
const URL_STATISTIC_DAILY = 'trans-service/reports/daily-point';
const URL_STATISTIC_DAILY_GAME_PROVIDER_LIST = 'adapter-service/providers/list';
const URL_STATISTIC_DAILY_AGENT_LIST = 'trans-service/agents/agent-list';

const URL_LIST_GAME_TYPE = '/trans-service/reports/list-game-type';
const URL_POINT_STATISTIC_BY_VENDOR = '/trans-service/reports/vendor-report';
const URL_POINT_STATISTIC_BY_VENDOR_CHART = '/trans-service/reports/vendor-statistic';
const URL_STATISTIC_LIST_VENDOR = 'adapter-service/providers/list';
const URL_DAILY_REVENUE_STATISTIC = 'trans-service/reports/daily-revenue';
const URL_EXPORT_REVENUE_STATISTIC = 'trans-service/reports/export-excel';

export const useStatisticAgentPoint = () => {
  return useMutation(async (param: IStatisticAgentPointParam) => {
    const data = await requestApi.post<IContentResponseApi<IStatisticAgentPointResponse>>(
      URL_STATISTIC_AGENT_POINT,
      param,
    );
    return data;
  });
};

export const usePointStatisticByVendorMutation = () => {
  return useMutation<IContentResponseApi, IResponseApi, object>(
    [StatisticsEnum.STATISTIC_POINT_BY_VENDOR],
    async (param) => {
      const { data } = await requestApi.post<IStatisticAgentPointListByVendorResponse>(
        URL_POINT_STATISTIC_BY_VENDOR,
        { ...param },
      );
      const dataConverted = pointStatisticsByVendor(data.content)
      return { content: dataConverted, totalElements: data.totalElements };
    },
  );
};

export const useStatisticAgentPointListByParent = () => {
  return useQuery([StatisticsEnum.STATISTIC_LIST_BY_PARENT], async () => {
    const { data } = await requestApi.get<Array<IStatisticAgentPointListByParentResponse>>(
      URL_STATISTIC_LIST_BY_PARENT,
    );
    return data;
  });
};

export const useStatisticAgentPointListVendor = () => {
  return useQuery([StatisticsEnum.STATISTIC_LIST_VENDOR], async () => {
    const { data } = await requestApi.get<Array<{ id: string; providerName: string }>>(URL_STATISTIC_LIST_VENDOR);
    return data;
  });
};

export const useStatisticAgentPointChildren = () => {
  return useMutation<Array<IStatisticAgentPointListByParentResponse>, IResponseApi, IStatisticAgentPointChildrenParam>(
    [StatisticsEnum.STATISTIC_LIST_AGENT_POINT_CHILDREN],
    async (param) => {
      const { data } = await requestApi.get<Array<IStatisticAgentPointListByParentResponse>>(
        URL_STATISTIC_LIST_BY_PARENT,
        param,
      );
      return data;
    },
  );
};

export const useStatisticPointByVendorChart = (param?: IStatisticVendorParamColumn) => {
  return useQuery([StatisticsEnum.STATISTIC_POINT_BY_VENDOR_CHERT_COMPANY, param], async () => {
    const { data } = await requestApi.post<{ statistic: IStatisticAgentByVendorChartDataResponse }>(
      URL_POINT_STATISTIC_BY_VENDOR_CHART,
      param,
    );
    return data.statistic;
  });
};

export const useStatisticDaily = () => {
  return useMutation(async (param: IStatisticDailyParam) => {
    const data = await requestApi.post<IContentResponseApi<IStatisticDailyResponse>>(URL_STATISTIC_DAILY, param);
    return data;
  });
};

export const useStatisticDailyGameProviderList = () => {
  return useQuery([StatisticsEnum.URL_STATISTIC_DAILY_GAME_PROVIDER_LIST], async () => {
    const { data } = await requestApi.get<Array<IStatisticDailyGameProviderListResponse>>(
      URL_STATISTIC_DAILY_GAME_PROVIDER_LIST,
    );
    return data;
  });
};

export const useStatisticDailyAgentListList = () => {
  return useQuery([StatisticsEnum.URL_STATISTIC_DAILY_AGENT_LIST], async () => {
    const { data } = await requestApi.get<Array<IStatisticDailyAgentListListResponse>>(URL_STATISTIC_DAILY_AGENT_LIST);
    return data;
  });
};

export const useListGameTypeQuery = () => {
  return useQuery([StatisticsEnum.STATISTIC_LIST_GAME_TYPE], async () => {
    const res = await requestApi.get<string[]>(URL_LIST_GAME_TYPE);
    return res.data;
  });
};

export const useGameTableStatistic = () => {
  return useMutation(async (param: IStatisticGameTableParam) => {
    const data = await requestApi.post<IContentResponseApi<IStatisticGameTableResponse>>(URL_DAILY_REVENUE_STATISTIC, param);
    return data;
  });
};

export const useExportTableStatistic = () => {
  return useMutation(async (param: IStatisticGameTableParam) => {
    const data = await requestApi.exportFile(URL_EXPORT_REVENUE_STATISTIC, param);
    return data;
  });
};

